









import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component({})
export default class SnackBarComponent extends Vue {
  @Prop(Number)
  timeout!: number;
  @Prop(String)
  color!: string;
  @Prop(Boolean)
  value!: boolean;
  @Prop(Boolean)
  showButton!: boolean;
  @Prop(Boolean)
  bottom!: boolean;

  closeTimeout: any;

  @Watch('value')
  changed() {
    if (this.value) {
      clearTimeout(this.closeTimeout);

      this.closeTimeout = setTimeout(() => {
        this.$emit('onSnackClose');
      }, this.timeout);
    }
  }

  clicked(value: any) {
    this.$emit('clicked', value);
  }
}
